import React, { useEffect } from "react";

const Redirect = ({ redirectUrl }) => {
  useEffect(() => {
     
    window.location.href = redirectUrl;
  }, []);
  return <div></div>;
};

export default Redirect;
